const windowWidth = window.innerWidth
let menu = document.querySelector('.menu')

if (menu) {
  const setMenu = () => {
    let menuNav = document.querySelector('.menu__nav')
    let menuBackground = document.querySelector('.menu__bg')
    let menuNavHeight = menuNav.clientHeight
    let menuContainerHeight = document.querySelector('.menu__container').clientHeight
    let menuPaddingTopBottom = parseInt(window.getComputedStyle(menu, null).getPropertyValue('padding-top')) * 2
    let defaultMenuHeight = `${menuContainerHeight + menuPaddingTopBottom}px`

    menuBackground.style.height = defaultMenuHeight

    document.querySelectorAll('.menu__list-item.has-submenu').forEach(item => {

      item.addEventListener('mouseenter', () => {
        let submenu = item.querySelector('.menu__sublist')
        let submenuHeight = submenu.clientHeight

        menuBackground.style.height = `${submenuHeight + menuNavHeight + menuPaddingTopBottom}px`
        menuBackground.classList.add('is-active')
        menu.classList.add('is-menu-opened')
        item.classList.add('is-active')
      })

      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-active')
        menu.classList.remove('is-menu-opened')
        menuBackground.style.height = defaultMenuHeight
        menuBackground.classList.remove('is-active')
      })
    })
  }

  setMenu()

  window.addEventListener('resize', function() {
    if (this.innerWidth != windowWidth) {
      setMenu()
    }
  })
}
